import { Route, Routes } from 'react-router-dom';
import { ErrorPage } from '../pages/error/ErrorPage';
import { NotFoundPage } from '../pages/error/NotFoundPage';
import { PageRouter } from './PageRouter';
import {SelectCertificate} from "../pages/SelectCertificate";
import {Consent} from "../pages/Consent";
import {Pin} from "../pages/Pin";
import {AuthProvider} from "../utils/authContext";
import {useState} from "react";
import { BodyClassController } from './BodyClassController';
import {ProtectedRoute} from "./ProtectedRoute";

const SIGNER_BASE_URL = process.env.REACT_APP_SIGNER_BASE_URL;
export const AppRouter = () => {
    const [fileName, setFileName] = useState('');


    return (
        <>
        <BodyClassController/>
            <AuthProvider>
                <Routes>
                    <Route path='*' element={<PageRouter fileName={fileName} setFileName={setFileName} />} />
                    <Route path='/*' element={<NotFoundPage />} />
                    <Route path='/error' element={<ErrorPage />} />
                    <Route element={<ProtectedRoute allowedBaseURL={SIGNER_BASE_URL} />}>
                        <Route path='/select-certificate' element={<SelectCertificate />} />
                        <Route path='/consent' element={<Consent fileName={fileName}/>} />
                        <Route path='/pin' element={<Pin />} />
                    </Route>
                </Routes>
            </AuthProvider>
        </>
    )
}